/**
 * Detect hero_image URLs that we know don't resolve to a real image.
 * When true, callers should skip <img> entirely and render BrandedHero instead.
 *
 * History: 88 blog posts were originally populated with
 *   https://instabridgefunding.com/images/blog/placeholder-hero.jpg
 * which was a placeholder path that never had a corresponding file. The SPA
 * fallback returns index.html (200 text/html) for the request, so the
 * browser shows a broken image icon.
 */
const KNOWN_BROKEN_PATTERNS = [
  /\/images\/blog\/placeholder-hero\.(jpg|jpeg|png|webp)(\?.*)?$/i,
];

export function isKnownBrokenHero(url) {
  if (!url || typeof url !== "string") return false;
  return KNOWN_BROKEN_PATTERNS.some((rx) => rx.test(url));
}
